import { createReducer, on } from '@ngrx/store';
import { warehousesActions } from '../actions/warehouses.actions';
import { Warehouse } from '../models';

export interface WarehousesState {
    loaded: boolean | null;
    loading: boolean;
    warehouses: Warehouse[];
    total: number;
}

export const initialState: WarehousesState = {
    loaded: null,
    loading: false,
    warehouses: [],
    total: 0,
};

export const warehousesReducer = createReducer(
    initialState,
    // Get
    on(warehousesActions.getWarehouses, (state): WarehousesState => ({
        ...state,
        loading: true,
    })),
    on(warehousesActions.getWarehousesSuccess, (state, { payload }): WarehousesState => ({
        ...state,
        loading: false,
        loaded: true,
        warehouses: payload.items,
        total: payload.total,
    })),
    on(warehousesActions.getWarehousesError, (state): WarehousesState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Clear
    on(warehousesActions.clear, (): WarehousesState => ({ ...initialState })),
);
